<template>
    <div class="agent-page">
        <div class="page-header">
           <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">中标公告</h2>
            </div>
           
        </div>

        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">文件名称:</label>
                <el-input v-model="searchForm.fileName" placeholder="请输入文件名称" class="search-input" clearable>
                </el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
             <div style="display: flex; gap: 12px;">
               
                <el-button type="primary" icon="el-icon-plus" @click="handleAddAddendum">添加补遗书</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="handleAddClarification">添加澄清文件</el-button>
                 <el-button type="primary" icon="el-icon-back" @click="handleBack">返回项目流程界面</el-button>
            </div>
            
        </div>

        <!-- 表格内容区域 -->
        <div class="table-container">
            <el-table :data="tableData" stripe border style="width: 100%"
                :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidInvitationDocumentsName" label="文件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidInvitationDocumentsCode" label="文件编码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidValidity" label="投标有效期(天)" align="center"></el-table-column>
                <el-table-column prop="bidOpeningTime" label="投标文件递交截止时间(开标时间)" align="center"></el-table-column>
                <el-table-column prop="decryptionDeadline" label="投标文件解密截止时间" align="center"></el-table-column>
                <el-table-column prop="documentType" label="文件类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.documentType === 1">文件</span>
                        <span v-if="scope.row.documentType === 2">补遗书</span>
                        <span v-if="scope.row.documentType === 3">澄清文件</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">暂存</span>
                        <span v-if="scope.row.status === 1">提交</span>
                    </template>
                </el-table-column>

                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <div class="action-buttons">
                            <el-button type="text" size="small" @click="handleViewDetails(scope.row)">详情</el-button>
                            <el-button v-if="scope.row.status === 0" type="text" size="small" @click="handleViewDel(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 补遗书弹窗 -->
        <el-dialog :title="isViewMode ? '补遗书详情' : '补遗书'" :visible.sync="addendumDialogVisible" width="50%"
            :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true" class="addendum-dialog">

            <el-form :model="addendumForm" label-width="200px" class="dialog-content">
                <!-- 招标项目名称 -->
                <el-form-item label="招标项目名称:" required>
                    <el-input v-model="addendumForm.projectName" placeholder="请输入招标项目名称" class="form-input"
                        :disabled="isViewMode">
                    </el-input>
                </el-form-item>
                <!-- 适用标段 -->
                <el-form-item label="适用标段:" required>
                    <el-select v-model="addendumForm.bidSectionCodes" placeholder="请先选择适用文件" class="form-input" multiple
                        collapse-tags disabled>
                        <el-option v-for="item in (addendumForm.bidSectionList || [])" :key="item.bidSectionCode"
                            :label="item.bidSectionName" :value="item.bidSectionCode" />
                    </el-select>
                </el-form-item>
                <!-- 适用文件（来自 initClarificationData 的 bidDocumentList，单选） -->
                <el-form-item label="适用文件:" required>
                    <el-select v-model="addendumForm.bidInvitationDocumentsCode" placeholder="请选择适用文件"
                        class="form-input" @change="handleBidDocumentChange" :disabled="isViewMode">
                        <el-option v-for="item in (clarificationBidDocumentList || [])"
                            :key="item.bidInvitationDocumentsCode" :label="item.bidInvitationDocumentsName"
                            :value="item.bidInvitationDocumentsCode" />
                    </el-select>
                </el-form-item>
                <!-- 补遗书名称（澄清/补遗书 文件名称） -->
                <el-form-item label="补遗书名称:" required>
                    <el-input v-model="addendumForm.bidInvitationDocumentsName" placeholder="请输入补遗书名称"
                        class="form-input" :disabled="isViewMode">
                    </el-input>
                </el-form-item>
                <!-- 投标文件递交截止时间(开标时间) -->
                <el-form-item label="投标文件递交截止时间:" required>
                    <app-date-picker v-model="addendumForm.bidOpeningTime" type="datetime" placeholder="选择日期时间"
                        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" class="form-input"
                        :disabled="isViewMode">
                    </app-date-picker>
                </el-form-item>
                <!-- 投标文件解密截止时间 -->
                <el-form-item label="投标文件解密截止时间:" required>
                    <app-date-picker v-model="addendumForm.decryptionDeadline" type="datetime" placeholder="选择日期时间"
                        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" class="form-input"
                        :disabled="isViewMode">
                    </app-date-picker>
                </el-form-item>
                <!-- 补遗内容 -->
                <el-form-item label="补遗内容:" required>
                    <el-input v-model="addendumForm.content" type="textarea" :rows="2" placeholder="请输入补遗内容"
                        class="form-textarea" :disabled="isViewMode">
                    </el-input>
                </el-form-item>
                <!-- 已上传的附件 -->
                <el-form-item label="已上传的附件:">
                    <el-table :data="addendumForm.attachments" style="width: 100%" border>
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="fileName" label="文件名" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width="150" align="center">
                            <template slot-scope="scope">
                                <el-button v-if="isViewMode" type="text" size="small"
                                    @click="handleDownloadAttachment(scope.row)">
                                    <i class="el-icon-download"></i> 下载
                                </el-button>
                                <el-button v-else type="text" size="small"
                                    @click="handleDeleteAttachment(scope.$index)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <!-- 附件上传 -->
                <el-form-item label="附件:" v-if="!isViewMode">
                    <div class="upload-area">
                        <el-button type="primary" icon="el-icon-upload2" @click="handleUploadClick">本地上传</el-button>
                        <div class="el-upload__tip">支持的文件类型：PDF、Word、图片等，单个文件不能超过10GB</div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="!isViewMode" type="primary" @click="handleSubmit(1)" class="submit-btn">提交</el-button>
                <el-button @click="addendumDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 澄清文件弹窗 -->
        <el-dialog title="添加澄清文件" :visible.sync="clarificationDialogVisible" width="50%" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" class="clarification-dialog">

            <el-form :model="addendumForm" :rules="addendumRules" label-width="200px" class="dialog-content">
                <!-- 招标项目名称 -->
                <el-form-item label="招标项目名称:" required style="width: 100%;">
                    <el-input v-model="addendumForm.projectName" placeholder="请输入招标项目名称" class="form-input">
                    </el-input>
                </el-form-item>

                <!-- 适用文件（澄清文件弹窗，必选） -->
                <el-form-item label="适用文件:" required style="width: 100%;">
                    <el-select v-model="addendumForm.bidInvitationDocumentsCode" placeholder="请选择适用文件"
                        class="form-input">
                        <el-option v-for="item in (clarificationBidDocumentList || [])"
                            :key="item.bidInvitationDocumentsCode" :label="item.bidInvitationDocumentsName"
                            :value="item.bidInvitationDocumentsCode" />
                    </el-select>
                </el-form-item>

                <!-- 开标15日之前时间限制 -->
                <el-form-item label="开标15日之前时间限制">
                    <el-checkbox v-model="addendumForm.cancelTimeLimit" class="time-limit-checkbox">
                        取消澄清文件必须在开标时间15日前发布的时间限制(澄清内容对投标人制作投标文件没有实质性影响)
                    </el-checkbox>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleEditTenderDocument" class="edit-tender-btn">编辑招标文件</el-button>
            </div>
        </el-dialog>

        <!-- 省平台审核情况弹窗 -->
        <el-dialog title="省平台审核情况" :visible.sync="statusDialogVisible" width="600px" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" class="status-dialog">

            <div class="status-content">
                <div class="status-item">
                    <span class="label">审核状态:</span>
                    <span class="value">{{ statusInfo.reviewStatus }}</span>
                </div>
                <div class="status-item">
                    <span class="label">原因备注:</span>
                    <span class="value">{{ statusInfo.reason }}</span>
                </div>
            </div>
        </el-dialog>

        <!-- 查看回执情况弹窗 -->
        <el-dialog title="查看回执情况" :visible.sync="acknowledgmentDialogVisible" width="600px"
            :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true"
            class="acknowledgment-dialog">
            <div class="acknowledgment-content">
                <el-table :data="acknowledgmentList" style="width: 100%" :show-header="true" border>
                    <el-table-column prop="companyName" label="投标公司名称" align="left" header-align="left">
                    </el-table-column>
                    <el-table-column prop="isAcknowledged" label="是否已回执" align="left" header-align="left">
                    </el-table-column>
                </el-table>
                <div v-if="acknowledgmentList.length === 0" class="no-data">
                    暂无数据
                </div>
            </div>
        </el-dialog>

        <!-- 文件下载记录弹窗 -->
        <el-dialog title="文件下载记录" :visible.sync="downloadDialogVisible" width="70%" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" class="download-dialog">
            <div class="download-content">
                <div class="download-subtitle">澄清文件下载记录</div>
                <el-table :data="downloadList" style="width: 100%" :show-header="true" border>
                    <el-table-column prop="no" label="NO." align="center" header-align="center" width="60">
                    </el-table-column>
                    <el-table-column prop="fileName" label="文件名称" align="left" header-align="left">
                    </el-table-column>
                    <el-table-column prop="fileCode" label="文件编码" align="left" header-align="left">
                    </el-table-column>
                    <el-table-column prop="sectionName" label="标段名称" align="left" header-align="left">
                    </el-table-column>
                    <el-table-column prop="bidderName" label="投标人名称" align="left" header-align="left">
                    </el-table-column>
                    <el-table-column prop="downloadCount" label="下载次数" align="center" header-align="center" width="100">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <!-- 文件上传进度对话框 -->
        <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" :show-close="false">
            <div class="upload-progress-content">
                <div class="upload-info">
                    <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
                    <span>{{ uploadProgress.fileName }}</span>
                </div>
                <el-progress :percentage="uploadProgress.percentage"
                    :status="uploadProgress.status === 'success' ? 'success' : (uploadProgress.status === 'error' ? 'exception' : null)"
                    style="margin-top: 20px;">
                </el-progress>
                <div class="upload-status" style="margin-top: 10px; text-align: center;">
                    <span v-if="uploadProgress.status === 'uploading'">正在上传...</span>
                    <span v-else-if="uploadProgress.status === 'success'" style="color: #67C23A;">上传成功</span>
                    <span v-else-if="uploadProgress.status === 'error'" style="color: #F56C6C;">上传失败</span>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { initBidInvitationDocumentsData, addBidInvitationDocumentsClarification, getClarificationListForCq, initClarificationData, getClarificationDetail, deleteBidInvitationDocuments } from '@/api/agent/api'
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { getFileList } from '@/api/base/api'
import { UPLOAD_CONSTANTS } from '@/utils/base'
import { doFileUpload } from '@/utils/fileUploadHelper'

const CONSTANTS = {
    ...UPLOAD_CONSTANTS,
    UPLOAD_STATUS: UPLOAD_CONSTANTS.STATUS
}

export default {
    name: 'TenderDocumentClarification',
    data() {
        return {
            projectCode: this.$route.query.projectCode,// 项目ID 
            fileBindId: '',
            projectTitle:'',
            // 搜索表单
            searchForm: {
                fileName: ''
            },
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            },
            // 表格数据
            tableData: [
            ],
            // 补遗书弹窗
            addendumDialogVisible: false,
            // 是否为查看模式（true:只读，false:可编辑）
            isViewMode: false,
            // 与 addBidInvitationDocumentsClarification 接口字段尽量对齐
            addendumForm: {
                cancelTimeLimit: true,
                // 选择的招标文件列表
                bidDocumentList: [],
                // 澄清/补遗书 文件编号 & 名称
                bidInvitationDocumentsCode: '', // 补遗书编号/适用文件编码
                bidInvitationDocumentsName: '', // 补遗书名称
                // 开标/递交截止时间 & 解密截止时间
                bidOpeningTime: '',
                decryptionDeadline: '',
                // 补遗内容
                content: '',
                // 关联信息
                fileGuid: '',
                projectCode: this.$route.query.projectCode,
                documentType: 2, // 补遗书
                status: 0, // 0 暂存，1 提交
                // 标段相关（来自初始化接口）
                bidSectionList: [],
                // 多选标段编码
                bidSectionCodes: [],
                // 本地附件展示使用
                attachments: []
            },
            // 澄清/补遗初始化中的招标文件列表（适用文件下拉数据源）
            clarificationBidDocumentList: [],
            // 澄清文件弹窗
            clarificationDialogVisible: false,
            clarificationForm: {
                projectName: '中山大厦项目',
                cancelTimeLimit: true
            },
            // 省平台审核情况弹窗
            statusDialogVisible: false,
            statusInfo: {
                reviewStatus: '未查询到',
                reason: ''
            },
            // 查看回执情况弹窗
            acknowledgmentDialogVisible: false,
            acknowledgmentList: [],

            // 文件下载记录弹窗
            downloadDialogVisible: false,
            downloadList: [],

            uploadUrl: '/api/upload',
            fileList: [],
            // 上传进度
            uploadProgress: {
                visible: false,
                percentage: 0,
                fileName: '',
                status: null
            }
        }
    },
    mounted() {
        this.initPage()
        //   当前时间戳+ 5位随机数
        this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
        this.getProjectInfo()
    },
    methods: {
           // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        initPage() {
            this.initBidInvitationDocumentsData()
            // this.getBidInvitationDocumentsList()
            this.getClarificationListForCq()
            this.initClarificationData()
        },
        //澄清列表
        getClarificationListForCq() {
            getClarificationListForCq(this.projectCode).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                    this.pagination.currentPage = res.data.current || 1
                }
            })
        },
        //初始化澄清-补遗 文件数据
        initClarificationData() {
            initClarificationData(this.projectCode).then(res => {
                if (res.code === 200) {
                    const data = res.data || {}
                    this.clarificationBidDocumentList = data.bidDocumentList || []
                } else {
                    this.$handleApiError(res, '获取澄清-补遗 文件数据失败', this)
                }
            })
        },
        // 初始化文件数据
        initBidInvitationDocumentsData() {
            initBidInvitationDocumentsData({ projectCode: this.projectCode }).then(res => {
                if (res.code === 200) {
                    const data = res.data || {}
                    this.addendumForm = {
                        ...this.addendumForm,
                        ...data,
                        bidSectionList: data.bidSectionList || this.addendumForm.bidSectionList || [],
                        attachments: data.attachments || this.addendumForm.attachments || [],
                    }

                } else {
                    this.$handleApiError(res, '获取文件绑定ID失败', this)
                }

            })
        },

        // 选择适用标段时（多选），保存选中的编码数组
        handleBidSectionChange(codes) {
            this.addendumForm.bidSectionCodes = Array.isArray(codes) ? codes : (codes ? [codes] : [])
        },

        // 选择适用文件时，根据编码回填名称
        handleBidDocumentChange(code) {
            const list = this.clarificationBidDocumentList || []
            const found = list.find(item => item.bidInvitationDocumentsCode === code)
            if (found) {
                this.addendumForm.bidInvitationDocumentsCode = found.bidInvitationDocumentsCode
                this.addendumForm.bidInvitationDocumentsName = found.bidInvitationDocumentsName
                // 自动填充该文件对应的标段列表
                this.addendumForm.bidSectionList = Array.isArray(found.bidSectionList) ? found.bidSectionList : []
                // 自动选中所有标段的 bidSectionCode
                this.addendumForm.bidSectionCodes = this.addendumForm.bidSectionList.map(item => item.bidSectionCode)
            } else {
                // 如果未找到，清空标段相关数据
                this.addendumForm.bidSectionList = []
                this.addendumForm.bidSectionCodes = []
            }
            if (found) {
                this.getClarificationDetail(found.bidInvitationDocumentsCode)
            }
        },

        // 新增文件文件类型（2：补遗书，3：澄清文件）
        addBidInvitationDocumentsClarification(value) {
            const params = {
                documentType: value,
            }
            addBidInvitationDocumentsClarification(params).then(res => {
                if (res.code === 200) {
                    this.$message.success('新增成功')
                    this.getBidInvitationDocumentsList()
                } else {
                    this.$handleApiError(res, '新增标书文件失败', this)
                }
            })
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 添加补遗书
        handleAddAddendum() {
            // 设置为编辑模式
            this.isViewMode = false
            this.addendumDialogVisible = true
        },

        // 添加澄清文件
        handleAddClarification() {
            this.clarificationDialogVisible = true
        },

        // 搜索
        handleSearch() {
            this.$message.info('搜索功能')
        },
        handleViewDel(row) {
            // 检查状态，只有暂存状态才能删除
            if (row.status !== 0) {
                this.$message.warning('只有暂存状态的文件才能删除')
                return
            }
            
            // 删除前确认提示
            this.$confirm('确定要删除该文件吗？删除后将无法恢复。', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteBidInvitationDocuments(row.bidInvitationDocumentsCode)
            }).catch(() => {

            })
        },

        // 删除标书文件
        async deleteBidInvitationDocuments(bidInvitationDocumentsCode) {
            try {
                const res = await deleteBidInvitationDocuments({ bidInvitationDocumentsCode: bidInvitationDocumentsCode })
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.getClarificationListForCq()
                } else {
                    this.$handleApiError(res, '删除标书文件失败', this)
                }
            } catch (error) {
                this.$handleError(error, '删除标书文件失败', this)
            }
        },

        // 查看详情
        handleViewDetails(row) {
            this.getClarificationDetail(row.bidInvitationDocumentsCode)
        },
        // 获取澄清-补遗 文件详情
        async getClarificationDetail(bidInvitationDocumentsCode) {
            try {
                const res = await getClarificationDetail(bidInvitationDocumentsCode)
                if (res.code === 200 && res.data) {
                    const data = res.data
                    // 如果 documentType 为 2，打开补遗书弹窗
                    if (data.documentType === 2) {
                        // 设置为查看模式
                        this.isViewMode = true
                        // 赋值补遗书表单数据
                        this.addendumForm = {
                            ...this.addendumForm,
                            bidInvitationDocumentsCode: data.bidInvitationDocumentsCode || '',
                            bidInvitationDocumentsName: data.bidInvitationDocumentsName || '',
                            documentType: data.documentType,
                            content: data.content || '',
                            fileGuid: data.fileGuid || '',
                            bidDocumentList: data.bidDocumentList || [],
                            bidSectionList: data.bidSectionConfig?.bidSectionList || [],
                            attachments: []
                        }

                        // 如果有 fileGuid，获取附件列表
                        if (data.fileGuid) {
                            await this.getAttachmentList(data.fileGuid)
                        }

                        // 打开补遗书弹窗
                        this.addendumDialogVisible = true
                    } else if (data.documentType === 3) {
                        // 如果是澄清文件，跳转到详情页面
                        this.$router.push({
                            path: '/tenderDocumentClarificationDetail',
                            query: {
                                projectCode: this.projectCode,
                                isViewMode: true,
                                bidInvitationDocumentsCode
                            }
                        })
                    }
                } else {
                    this.$message.error(res.msg || '获取详情失败')
                }
            } catch (error) {
                console.error('获取澄清-补遗 文件详情失败:', error)
                this.$message.error('获取详情失败')
            }
        },

        // 获取附件列表
        async getAttachmentList(fileGuid) {
            if (!fileGuid) {
                this.addendumForm.attachments = []
                return
            }
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    // 将附件数据转换为表单需要的格式
                    this.addendumForm.attachments = res.data.map(file => ({
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileExtension: file.fileExtension,
                        fileSize: file.fileSize,
                        fileUrl: file.fileUrl
                    }))
                } else {
                    this.addendumForm.attachments = []
                }
            } catch (error) {
                console.error('获取附件列表失败:', error)
                this.addendumForm.attachments = []
            }
        },

        // 下载附件
        handleDownloadAttachment(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank')
            } else {
                this.$message.warning('文件下载链接不存在')
            }
        },

        // 查看状态
        handleViewStatus(row) {
            this.statusInfo = {
                reviewStatus: '未查询到',
                reason: ''
            }
            this.statusDialogVisible = true
        },

        // 补遗书弹窗相关方法
        // 删除附件
        handleDeleteAttachment(index) {
            this.addendumForm.attachments.splice(index, 1)
        },

        // 点击上传按钮
        handleUploadClick() {
            this.createFileInput()
        },

        // 创建文件输入框
        createFileInput() {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = CONSTANTS.SUPPORTED_FILE_TYPES || '.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx'
            input.onchange = (e) => {
                this.handleFileSelect(e)
            }
            input.click()
        },

        // 处理文件选择
        async handleFileSelect(event) {
            const file = event.target.files[0]
            if (!file || !this.validateFile(file)) return

            try {
                this.showUploadProgress(file)
                const uploadResult = await this.uploadFileWithChunks(file)
                this.handleUploadResult(uploadResult, file)
            } catch (error) {
                this.handleUploadError(error, file)
            }
        },

        // 验证文件
        validateFile(file) {
            const maxSize = 10 * 1024 * 1024 * 1024 // 10GB
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过10GB')
                return false
            }
            const allowedTypes = (CONSTANTS.SUPPORTED_FILE_TYPES || '.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx').split(',')
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
            if (!allowedTypes.includes(fileExtension)) {
                this.$message.error('不支持的文件类型')
                return false
            }
            return true
        },

        // 显示上传进度
        showUploadProgress(file) {
            this.uploadProgress = {
                visible: true,
                percentage: 0,
                fileName: file.name,
                status: CONSTANTS.UPLOAD_STATUS?.UPLOADING || 'uploading'
            }
        },

        // 上传文件
        async uploadFileWithChunks(file) {
            let uploadedFileId = null
            const uploadResult = await doFileUpload(file, {
                fileBindId: this.fileBindId,
                onProgress: (progress) => {
                    this.uploadProgress.percentage = Math.round(Number(progress) || 0)
                },
                onSuccess: (r) => {
                    uploadedFileId = r.fileId || r.id || ''
                },
                onError: () => { }
            })
            if (uploadResult && uploadedFileId) {
                uploadResult.fileId = uploadedFileId
            }
            return uploadResult
        },

        // 处理上传结果
        handleUploadResult(uploadResult, file) {
            if (uploadResult && uploadResult.success) {
                this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS?.SUCCESS || 'success'
                this.uploadProgress.percentage = 100
                const fileId = uploadResult.fileId || uploadResult.id || ''
                if (fileId) {
                    if (!Array.isArray(this.addendumForm.attachments)) {
                        this.addendumForm.attachments = []
                    }
                    this.addendumForm.attachments.push({
                        fileName: file.name,
                        fileId: fileId,
                        uploadTime: new Date().toLocaleString()
                    })
                    // 将上传绑定标识写入 fileGuid，供接口使用
                    if (!this.addendumForm.fileGuid) {
                        this.addendumForm.fileGuid = this.fileBindId
                    }
                }
                setTimeout(() => {
                    this.uploadProgress.visible = false
                    this.$message.success(`文件 ${file.name} 上传成功`)
                }, 1000)
            } else {
                this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS?.ERROR || 'error'
                setTimeout(() => {
                    this.uploadProgress.visible = false
                    this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
                }, 1000)
            }
        },

        // 处理上传错误
        handleUploadError(error, file) {
            this.uploadProgress.status = CONSTANTS.UPLOAD_STATUS?.ERROR || 'error'
            setTimeout(() => {
                this.uploadProgress.visible = false
                this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
            }, 1000)
        },

        // 提交补遗书（status: 0 暂存，1 提交）
        handleSubmit(status) {
            // 验证必填字段
            if (!this.addendumForm.bidInvitationDocumentsName) {
                this.$message.error('请输入补遗书名称')
                return
            }
            if (!this.addendumForm.bidOpeningTime) {
                this.$message.error('请选择投标文件递交截止时间')
                return
            }
            if (!this.addendumForm.decryptionDeadline) {
                this.$message.error('请选择投标文件解密截止时间')
                return
            }
            if (!this.addendumForm.content) {
                this.$message.error('请输入补遗内容')
                return
            }

            // 从澄清/补遗初始化返回的 clarificationBidDocumentList 中，
            // 根据当前选中的适用文件编码构造 bidDocumentList
            const selectedCode = this.addendumForm.bidInvitationDocumentsCode
            let bidDocumentList = []
            if (selectedCode) {
                const list = this.clarificationBidDocumentList || []
                const found = list.find(item => item.bidInvitationDocumentsCode === selectedCode)
                if (found) {
                    bidDocumentList = [{
                        bidInvitationDocumentsCode: found.bidInvitationDocumentsCode,
                        bidInvitationDocumentsName: found.bidInvitationDocumentsName
                    }]
                }
            }
            const data = {
                bidDocumentList,
                // bidInvitationDocumentsCode: this.addendumForm.bidInvitationDocumentsCode || '',
                bidInvitationDocumentsName: this.addendumForm.bidInvitationDocumentsName || '',
                bidOpeningTime: this.addendumForm.bidOpeningTime || '',
                content: this.addendumForm.content || '',
                decryptionDeadline: this.addendumForm.decryptionDeadline || '',
                documentType: 2,
                fileGuid: this.addendumForm.fileGuid || this.fileBindId || '',
                projectCode: this.projectCode || '',
                status
            }
            addBidInvitationDocumentsClarification(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('提交成功')
                    this.addendumDialogVisible = false
                    this.getClarificationListForCq()
                } else {
                    this.$handleApiError(res, '保存补遗书失败', this)
                }
            })
        },
        // 编辑招标文件
        handleEditTenderDocument() {
            // 校验已选择适用文件
            if (!this.addendumForm.bidInvitationDocumentsCode) {
                this.$message.error('请选择适用文件')
                return
            }
            this.clarificationDialogVisible = false
            this.$router.push({
                path: '/agentHome/clarification',
                query: {
                    projectCode: this.projectCode,
                    bidInvitationDocumentsCode: this.addendumForm.bidInvitationDocumentsCode
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.table-container {

    .action-buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;

        .el-button {
            margin: 0;
            padding: 5px 8px;
            font-size: 12px;
        }
    }

    .status-text {
        color: #67c23a;
        font-weight: bold;
    }
}

// 澄清文件弹窗样式
.clarification-dialog {
    .dialog-footer {
        text-align: center;
        padding: 20px 0;

        .edit-tender-btn {
            background-color: #409eff;
            border-color: #409eff;
            color: #fff;
            padding: 10px 30px;
            font-size: 14px;
        }
    }
}

// 省平台审核情况弹窗样式
.status-dialog {
    .status-content {

        .status-item {
            display: flex;
            margin-bottom: 15px;
            line-height: 1.5;

            .label {
                color: #606266;
                font-size: 14px;
                min-width: 80px;
                margin-right: 10px;
            }

            .value {
                color: #303133;
                font-size: 14px;
                flex: 1;
            }
        }
    }
}

// 查看回执情况弹窗样式
.acknowledgment-dialog {
    .acknowledgment-content {
        .no-data {
            text-align: center;
            color: #909399;
            font-size: 14px;
            padding: 40px 0;
            border: 1px solid #dcdfe6;
            border-top: none;
        }

        .el-table {
            .el-table__header {
                th {
                    background-color: #f5f7fa;
                    color: #606266;
                    font-weight: 500;
                }
            }

            .el-table__body {
                td {
                    color: #303133;
                }
            }
        }
    }
}

// 文件下载记录弹窗样式
.download-dialog {
    .download-content {
        .download-subtitle {
            color: #606266;
            font-size: 14px;
            margin-bottom: 15px;
            font-weight: 500;
        }
    }
}

// 上传区域样式
.upload-area {
    .el-upload__tip {
        color: #909399;
        font-size: 12px;
        margin-top: 8px;
    }
}

// 上传进度弹窗样式
.upload-progress-content {
    .upload-info {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #333;
    }

    .upload-status {
        font-size: 14px;
    }
}
</style>
